import ICartItem from '~domain/entities/CartItem/ICartItem';
import IProduct from '~domain/entities/Product/IProduct';
import { IPGKitItems } from '~api/KitsAPI/utils/IKits';
import { toBoolean } from '~utils/ToBoolean';
import { engravingMapper } from '~api/KitsAPI/utils/engravingMapper';
import { getKitTypeData } from '~api/KitsAPI/utils/getKitTypeData';

const emptyProduct: IProduct = {
    productId: '',
    name: '',
    description: '',
    skuLabel: '',
    url: '',
    price: 0,
    shade: '',
    shadeCode: '',
    size: '',
    thumb: '',
    isSample: false,
    isPricedSample: false,
    baseName: '',
    altThumb: []
};

export const mapKits = (kits: IPGKitItems[]) =>
    kits.reduce((kitsAccum, item) => {
        const {
            name,
            thumb,
            kitItems,
            quantity,
            price,
            shade,
            shadeCode,
            size,
            url,
            description,
            discountPercent,
            discountedUnitPrice,
            discountedUnitPriceWithTax,
            appliedPrice,
            appliedPriceWithTax
        } = getKitTypeData(item);
        const engraving = engravingMapper(item);

        const kitItem: ICartItem = {
            isOutOfStock: toBoolean(item['sku.isOutOfStock']),
            discountPercent,
            discountedUnitPrice,
            discountedUnitPriceWithTax,
            unitPriceWithTax: price,
            skuId: item.sku_string || item.SKU_BASE_ID?.toString(),
            quantity,
            appliedPrice,
            appliedPriceWithTax,
            hasEngraving: !!item.hasEngraving,
            engraving,
            product: {
                ...emptyProduct,
                size,
                shade,
                shadeCode,
                name,
                description,
                price,
                thumb,
                url
            },
            isKitItem: true,
            isReplenishable: toBoolean(item['sku.REFILLABLE']),
            enableReplenishment: false,
            replenishmentOptions: [],
            replenishmentInfo: {
                collectionId: item.COLLECTION_ID,
                replenishmentToken: ''
            },
            kitInfo: {
                collection: {
                    id: item.COLLECTION_ID,
                    name: item.COLLECTION_NAME,
                    type: item.COLLECTION_TYPE,
                    subtype: item.COLLECTION_SUBTYPE
                },
                cartId: item.CART_ID,
                name: item?.ukitCustomDetails?.title || item.COLLECTION_NAME,
                thumb: item?.ukitCustomDetails?.image,
                kitItems
            }
        };

        return [...kitsAccum, kitItem];
    }, []);
